/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'log': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M111.688 81.25L100 43.75H50l-13.312 37.5H56.25l6.25 12.5h25l6.25-12.5h17.938zM125 118.75H25V80.625L43.75 31.25h62.5L125 80.625v38.125z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
